import { getSortedGroupedBookedGroupMembers } from "@myaccount/_components/my-group-members/_client/hooks/get-sorted-grouped--booked-group-members";
import { useI18n } from "@wojo/localization";
import { Card, SelectDropdown, SelectDropdownItem, Text } from "@wojo/ui";
import {
    ConfirmedRequestedGroupMemberTripsFragment,
    GroupMembersDepartureFragment,
} from "generated/graphql";
import React, { useId, useState } from "react";
import styles from "./BookedTravelers.module.scss";
import { BookedTravelersPages } from "./BookedTravelersPages";

export type BookedTravelersProps = {
    departure: GroupMembersDepartureFragment;
    bookedTravelers: ConfirmedRequestedGroupMemberTripsFragment[];
    hasExtension: boolean;
};

export const BookedTravelers: React.FC<BookedTravelersProps> = (props) => {
    const { bookedTravelers, departure, hasExtension } = props;
    const headingId = useId();
    const emailHelpTextId = useId();
    const i18n = useI18n("account").account.myGroupMembers.bookedTravelers;

    const [selectedPage, setSelectedPage] = useState<string>("TourStatus");

    const handlePageChange = (value: string) => {
        if (value) {
            setSelectedPage(value);
        }
    };

    const groupedOrders = getSortedGroupedBookedGroupMembers(
        bookedTravelers,
        true,
    );

    if (groupedOrders.length === 0) {
        return null;
    }

    const pageOptions: SelectDropdownItem<string>[] = [
        { value: "TourStatus", label: i18n.selectorOptions.tourStatus.l() },
        { value: "Terms", label: i18n.selectorOptions.terms.l() },
        { value: "Balances", label: i18n.selectorOptions.balances.l() },
        { value: "Flights", label: i18n.selectorOptions.flights.l() },
        ...(departure.excursions.length > 0
            ? [
                  {
                      value: "Excursions",
                      label: i18n.selectorOptions.excursions.l(),
                  },
              ]
            : []),
        {
            value: "TravelProtection",
            label: i18n.selectorOptions.travelProtection.l(),
        },
        { value: "Rooming", label: i18n.selectorOptions.rooming.l() },
        { value: "ContactInfo", label: i18n.selectorOptions.contactInfo.l() },
    ];

    return (
        <div>
            <section
                aria-labelledby={headingId}
                style={{
                    paddingTop: "var(--g-spacing-xl)",
                    marginBottom: "var(--g-spacing-xl)",
                }}
            >
                <Text.Heading
                    id={headingId}
                    order="3"
                    tag="h2"
                    style={{ paddingBottom: "var(--g-spacing-md)" }}
                >
                    {i18n.heading.l()}
                </Text.Heading>

                <Card>
                    <div className={styles.dropdown}>
                        <SelectDropdown
                            items={pageOptions}
                            value={selectedPage}
                            onChange={handlePageChange}
                            label={i18n.topicSelectorText.l()}
                            fieldId="page-select"
                        />
                    </div>
                    <BookedTravelersPages
                        departure={departure}
                        selectedPage={selectedPage}
                        bookedSortedTravelers={groupedOrders}
                        hasExtension={hasExtension}
                        emailHelpTextId={emailHelpTextId}
                    />
                </Card>
                <Text.Body
                    id={emailHelpTextId}
                    className={styles.email}
                    variant="2"
                >
                    {i18n.emailHelpText.l()}
                </Text.Body>
            </section>
        </div>
    );
};
